module.exports = "<div class=\"ratings-wrap\">\n  <span class=\"rating\">{{rating || 0}}</span>\n  <div class=\"expanded-rating\">\n    <div class=\"star-rating\">\n      <span *ngFor=\"let i of [1,2,3,4,5,6,7,8,9,10]\" class=\"star\" [class.on]=\"i < rating\"></span>\n    </div>\n    <div class=\"user-voted\">\n      <i class=\"fa fa-user\"></i> {{votes || 0}} Oy\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/shared/widgets/rating-stars/rating-stars.component.html
// module id = ../../../../../src/app/shared/widgets/rating-stars/rating-stars.component.html
// module chunks = main